import { createDecorator } from '../../instantiation/common/instantiation.js';
const IKeyboardLayoutService = ( createDecorator('keyboardLayoutService'));
export { IKeyboardLayoutService };
